module.exports = __webpack_public_path__ + "img/landing-04.a52e32fc.png";